module.exports = __webpack_public_path__ + "static/img/4-03.e8c11cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-03.png
// module id = 27
// module chunks = 0